import { Button, Flex, Typography } from 'antd';
import React from 'react';
import { ReactComponent as EmptyListIcon } from 'src/assets/icons/empty-list-placeholder.svg';
import PropTypes from 'prop-types';

export default function EmptyListPlaceholder({
  onBrowseTemplates,
  onAddAllTemplates,
  isAddingAllTemplates
}) {
  return (
    <Flex style={{ padding: 16 }} vertical align="center" gap={10}>
      <EmptyListIcon />
      <Typography.Title level={4}>No Intents yet</Typography.Title>
      <Typography.Paragraph level={2}>
        Add your first intents by clicking create intent or browse our library of templates to
        start.
      </Typography.Paragraph>
      <Flex gap={6}>
        <Button onClick={onBrowseTemplates}>Browse templates</Button>
        <Button loading={isAddingAllTemplates} onClick={onAddAllTemplates} type="primary">
          Add all templates
        </Button>
      </Flex>
    </Flex>
  );
}

EmptyListPlaceholder.propTypes = {
  onBrowseTemplates: PropTypes.func.isRequired,
  onAddAllTemplates: PropTypes.func.isRequired,
  isAddingAllTemplates: PropTypes.bool.isRequired
};
